import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Axios from "axios";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import constants from "../constants/constants.json";
import Message from "../helper/Message";
import { Row, Col, Table, Card, Divider, Result, Button } from "antd";
import moment from "moment";

export default function Callback(props) {
  const [loading, setloading] = useState(true);
  const [callbackResult, setCallBackResult] = useState(false);
  const history = useHistory();
   
  const columnsPay = [
    {
      title: "Payment Price",
      dataIndex: "value",
      kay: "value",
    },
    {
      title: "Payment Reference",
      dataIndex: "refrence",
      kay: "refrence",
      render: (text, time, index) => {
        if (text === null) {
          return "N/A";
        } else {
          return text;
        }
      },
    },
    {
      title: "Payment Gateway",
      dataIndex: "gateway",
      kay: "gateway",
    },
    {
      title: "Payment Status",
      dataIndex: "status",
      kay: "status",
      render: (text, time, index) => {
        return text === 1 ? (
          <CheckCircleOutlined style={{ fontSize: "24px", color: "green" }} />
        ) : (
          <CloseCircleOutlined style={{ fontSize: "24px", color: "red" }} />
        );
      },
    },
    {
      title: "Payment Time",
      dataIndex: "payTime",
      kay: "payTime",
      render: (text, time, index) => {
        return moment.unix(text).format("YYYY/MM/DD HH:mm");
      },
    },
  ];
  const columns = [
    {
      title: "Plan Name",
      dataIndex: "name",
      key: "name",
    },

    {
      title: "Plan Features",
      dataIndex: "features",
      key: "features",
      render: (features) => {
        return (
          <ul>
            {features &&
              features.split("\n").map((element) => {
                return <li>{element}</li>;
              })}
          </ul>
        );
      },
    },

    {
      title: "Time Limit",
      dataIndex: "limit",
      key: "limit",
      render: (limit) => {
        return limit && <span>{limit / 3600} Hrs</span>;
      },
    },
    {
      title: "Plan Price",
      dataIndex: "value",
      key: "value",
    },
  ];

  const ClaabackReq = async () => {
    try {
      setloading(true);
      let id = new URLSearchParams(window.location.search).get("id");
      
      let token = localStorage.getItem("pnsToken");
      let response = await Axios.get(constants.url + "/plan/callback/" + id, {
        headers: {
          authorization: "Bearer " + token,
        },
      });

      if (response.data.status === 202) {
        setCallBackResult(response.data.result);
        setloading(false);
        response.data.result.payment.status === 1
          ? Message.success("Payment Successfull")
          : Message.error("Payment Unsuccessfull");
      } else {
        Message.error(response.data.result.message);
        setloading(false);
      }
    } catch (err) {
      Message.error("Communication error");
      setloading(false);
    }
  };

  useEffect(() => {
    ClaabackReq();
  }, []);
  return !loading ? (
    <Row justify="center">
      <Col xs={24} sm={24} md={20} lg={18} xl={15}>
        <Card>
          <Row justify="center">
            <Result
              status={callbackResult.payment.status === 1 ? "success" : "error"}
              title={
                callbackResult.payment.status === 1
                  ? `Successfully Purchased ${callbackResult.plan.name}!`
                  : `There are some problems with your operation.`
              }
              subTitle={
                callbackResult.payment.status === 1
                  ? `Order number: ${callbackResult.invoice.uid} compeleted with payment id : ${callbackResult.payment.refrence}`
                  : `Order number: ${callbackResult.invoice.uid} not completed.`
              }
            />
          </Row>
          <Row justify="center">
            <span className="chaeckout-card-title">Invoice</span>
          </Row>
          <Row justify="center" className="checkout-invoice">
            <span className="checkout-invoice-detail">
              Invoice Date:{" "}
              {moment
                .unix(callbackResult.invoice.createTime)
                .format("YYYY/MM/DD HH:mm")}
            </span>
            <span className="checkout-invoice-detail">
              Invoice Id: {callbackResult.invoice.uid}
            </span>
          </Row>
          <div className="checkout-card-details">
            <div className="checkout-seller">
              <span className="checkout-seller-name">Seller Name: Pns</span>
              <span className="checkout-seller-name">
                Seller Tel: +989123456789
              </span>
            </div>
            <div className="checkout-buyer">
              <span className="checkout-buyer-name">
                Buyer Name: {callbackResult.user.name}
              </span>
              <span className="checkout-buyer-mail">
                Buyer Mail: {callbackResult.user.mail}
              </span>
            </div>
          </div>
          <div className="checkout-table-container">
            <Table
              dataSource={[
                callbackResult.plan,
                { value: callbackResult.plan.value },
              ]}
              bordered
              columns={columns}
              pagination={false}
            />
          </div>
          <Divider style={{ margin: "50px 0 30px 0" }}>Payment info</Divider>
          <div className="checkout-table-container">
            <Table
              dataSource={[callbackResult.payment]}
              bordered
              columns={columnsPay}
              pagination={false}
            />
          </div>
          <Button
            type="primary"
            onClick={() => history.push("/dashboard/projects")}
            style={{
              marginTop: "20px",
            }}
          >
            Return to Projects
          </Button>
        </Card>
      </Col>
    </Row>
  ) : (
    <span>loading</span>
  );
}
